// Package Imports
import { queryOptions, useMutation } from '@tanstack/react-query'

// Core Imports
import type { TResponseError } from '@/core/types/axios'
import type { TMutation } from '@/core/types/react-query'

// Module Imports
import {
  authUser,
  forgotPassword,
  resetPassword,
  signIn,
  signOut,
} from '@/modules/auth/auth.service'
import type {
  TForgotPasswordRequest,
  TResetPasswordRequest,
  TSignInRequest,
  TSignInResponse,
} from '@/modules/auth/auth.types'

export const authUserQueryOptions = () =>
  queryOptions({
    queryKey: ['authUser'],
    queryFn: authUser,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  })

export function useSignIn({
  onSuccess,
  onError,
}: TMutation<TSignInResponse, TResponseError, TSignInRequest>) {
  return useMutation<TSignInResponse, TResponseError, TSignInRequest>({
    mutationFn: signIn,
    onSuccess,
    onError,
  })
}

export function useForgotPassword({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, TForgotPasswordRequest>) {
  return useMutation<void, TResponseError, TForgotPasswordRequest>({
    mutationFn: forgotPassword,
    onSuccess,
    onError,
  })
}

export function useResetPassword({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, TResetPasswordRequest>) {
  return useMutation<void, TResponseError, TResetPasswordRequest>({
    mutationFn: resetPassword,
    onSuccess,
    onError,
  })
}

export function useSignOut({
  onSuccess,
  onError,
}: TMutation<void, TResponseError, null>) {
  return useMutation<void, TResponseError, null>({
    mutationFn: signOut,
    onSuccess,
    onError,
  })
}
